import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const columns = (history, showModal) =>[
    {
      title: "Code",
      dataIndex: "sampleCode",
      key: "sampleCode",
    },
    // -------------------------
    {
      title: "Nom d'échantillon",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          
          {/* BOUTON MODIFIER (Bleu foncé arrondi) */}
          <Button
            className="btn-details" 
            onClick={() => history.push(`edit/sample/${record.id}`)}
            icon={<EditOutlined />}
          >
            Modifier
          </Button>
  
          {/* BOUTON SUPPRIMER (Icône Rouge) */}
          <Button 
              type="text" 
              danger 
              onClick={() => showModal(record.id)}
              icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
          />
        </div>
      ),
    },
  ];